import moment from 'moment'
import { apiFormat, format } from '@cbgms/base/utils/datetime'
import { ShopResponse } from 'app-support/messages/interfaces/interface'

export const firstYearFn = (yearOffset: number) =>
  moment()
    .add(yearOffset - 4, 'years')
    .startOf('year')
    .format(apiFormat.yearMonthDay)
export const lastYearFn = (yearOffset: number) => moment().add(yearOffset, 'years').endOf('year').format(apiFormat.yearMonthDay)
export const startOfYear = moment().startOf('year').format(apiFormat.yearMonthDay)
export const endOfYear = moment().endOf('year').format(apiFormat.yearMonthDay)
export const startOfYearFn = (selectedYear: string) => moment(selectedYear, format.year).startOf('year').format(apiFormat.yearMonthDay)
export const endOfYearFn = (selectedYear: string) => moment(selectedYear, format.year).endOf('year').format(apiFormat.yearMonthDay)

export const fetchShopId = (value: string | string[]) => {
  if (typeof value === 'string') {
    const values = value.split('-')
    return values[0].trim()
  }
}

export const mapShopIdToLabel = (data: ShopResponse) => {
  const formatShopInfo = (...fields: (string | undefined)[]) => fields.filter(field => !!field).join(' - ') // Filter and join in one step
  const mappedShopData = {
    text: formatShopInfo(data.ID, data.Name, data.VisitorCity),
    key: data.ID,
    value: formatShopInfo(data.ID, data.Name, data.VisitorCity)
  }

  return mappedShopData
}
